module.exports = __webpack_public_path__ + "static/media/shape3_7.96271af4.obj";